module.exports = "<div class=container> <a ng-href=/#admin/users>Users</a> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/admin/admin.html
 ** module id = 166
 ** module chunks = 0
 **/